<template>
  <transition appear name="fade">
    Related
    <table style="width: 100%" v-if="store.state.relatedArticles.length != 0">
      <thead>
        <tr>
          <td>Year</td>
          <td>Title</td>
          <td>Venue</td>
          <td>DOI/Publisher Link</td>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(article, index) in store.state.relatedArticles"
          v-bind:key="index"
        >
          <td>{{ article["Publication year"] }}</td>
          <td class="article-title">
            <a @click="store.setSelectedArticle(article)">{{
              article["Title"]
            }}</a>
          </td>
          <td>{{ article.Venue }}</td>
          <td>
            <a :href="article.DOI">Article Link</a>
          </td>
        </tr>
      </tbody>
    </table>
  </transition>
</template>
<script>
import { store } from "@/store";
export default {
  data() {
    return {
      store
    };
  },
  methods: {
    updateArticle(article) {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
      store.setSelectedArticle(article);
    }
  }
};
</script>
<style>
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.article-title a {
  color: black;
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
  font-size: 16px;
}
.article-title a:hover {
  font-weight: bold;
  font-style: normal;
  text-decoration: none;
}
</style>
